import { z } from 'zod';

import { locales } from '@Common/i18n/i18n';

export type LanguageCode = Uppercase<Extract<keyof typeof locales, string>>;
export const LanguageCodeValues = Object.keys(locales).map((locale) => locale.toUpperCase());
export const ZodLanguageCode = z.enum(LanguageCodeValues as [LanguageCode, ...LanguageCode[]]);

export const CountryLanguageValues = [
  'FR',
  'EN',
  'PL',
  'PT',
  'SV',
  'LV',
  'HU',
  'SL',
  'DA',
  'LT',
  'DE',
  'IT',
  'NL',
  'ES',
] as const;

export const ZodCountryLanguage = z.enum(CountryLanguageValues);
